import React from 'react';
import { Button, DialogContent, Typography } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';

import { InfoIcon } from 'assets';

import styles from './CheckYourDeviceDialog.module.scss';

export interface CheckYourDeviceDialogProps extends DialogProps {
  onClose: () => void;
  onConfirm: () => void;
}

export function CheckYourDeviceDialog({ onClose, onConfirm, ...rest }: CheckYourDeviceDialogProps) {
  const { t } = useTranslation('providerRoom');

  return (
    <Dialog {...rest} className={styles.dialog}>
      <DialogContent>
        <InfoIcon className={styles.icon} />

        <Typography color='error' variant='body4'>
          {t('checkYourDeviceDialog.title')}
        </Typography>

        <Typography variant='body2'>{t('checkYourDeviceDialog.description')}</Typography>

        <div className={styles.buttons}>
          <Button variant='outlined' onClick={onConfirm}>
            {t('checkYourDeviceDialog.openSettings')}
          </Button>

          <Button variant='contained' onClick={onClose}>
            {t('checkYourDeviceDialog.dismiss')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
